import Vue from "vue";
import Router from "vue-router";
import readyCourse from "./ready-course";
import giveCourse from "./give-course";
import teachEffect from "./teach-effect";
import jxeffectTwo from "./jxeffect-two";
Vue.use(Router);
const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/login"),
    },
    {
      path: "/register",
      name: "register",
      component: () => import("@/views/register"),
    },
    {
      path: "/resourceStatistics/index3",
      name: "resourceStatistics",
      component: () => import("@/views/schoolLevel/resourceStatistics/index"),
    },
    {
      path: "/resourceStatistics/index2",
      name: "resourceStatisticsIndex2",
      component: () => import("@/views/schoolLevel/resourceStatistics/index2"),
    },
    {
      path: "/resourceStatistics/index",
      name: "resourceStatisticsIndex",
      component: () => import("@/views/schoolLevel/resourceStatistics/index3"),
    },
    {
      path: "/resourceStatistics/resourceAnalyse",
      name: "resourceStatisticsResourceAnalyse",
      component: () =>
        import("@/views/schoolLevel/resourceStatistics/common.vue"),
      redirect: "/resourceStatistics/resourceAnalyse",
      children: [
        {
          path: "/resourceStatistics/resourceAnalyse",
          name: "resourceStatisticsResourceAnalyse",
          component: () =>
            import("@/views/schoolLevel/resourceStatistics/resourceAnalyse"),
        },
        {
          path: "/resourceStatistics/teacherAnalyse",
          name: "resourceStatisticsTeacherAnalyse",
          component: () =>
            import("@/views/schoolLevel/resourceStatistics/teacherAnalyse"),
        },
        {
          path: "/resourceStatistics/studentAnalyse",
          name: "resourceStatisticsStudentAnalyse",
          component: () =>
            import("@/views/schoolLevel/resourceStatistics/studentAnalyse"),
        },
        {
          path: "/resourceStatistics/userAnalyse",
          name: "resourceStatisticsUserAnalyse",
          component: () =>
            import("@/views/schoolLevel/resourceStatistics/userAnalyse"),
        },
      ],
    },
    // 微信分享
    {
      path: "/WeChatShare",
      name: "WeChatShare",
      component: () => import("@/components/WeChatShare"),
    },
    // pdf预览
    {
      path: "/pdfPreview",
      name: "pdfPreview",
      component: () => import("@/components/pdfPreview"),
    },
    // {
    //   path: "",
    //   name: "temLayout",
    //   component: () => import("@/views/schoolLevel/temLayout"),
    //   redirect: "/home1",
    //   children: [

    //   ],
    // },
    {
      path: "",
      name: "HomeLayout",
      component: () => import("@/views/layout"),
      // redirect: "/custom/Power_Automation/home",
      redirect: "/homePage",
      children: [
        {
          path: "/homePage",
          name: "homePage",
          component: () => import("@/views/homePage"),
        },
        {
          path: "/schoolLevel/list",
          name: "schoolLevelList",
          component: () => import("@/views/schoolLevel/list.vue"),
        },
        {
          path: "/schoolLevel/detail",
          name: "schoolLevelDetail",
          component: () => import("@/views/schoolLevel/detail.vue"),
        },
        {
          path: "/schoolLevel/majorList",
          name: "schoolMajorList",
          component: () =>
            import("@/views/schoolLevel/majorCenter/majorList1.vue"),
        },

        {
          path: "/schoolLevel/majorList1",
          name: "schoolMajorList1",
          component: () =>
            import("@/views/schoolLevel/majorCenter/majorList1.vue"),
        },
        {
          path: "/schoolLevel/majorDetail",
          name: "schoolMajorDetail",
          component: () =>
            import("@/views/schoolLevel/majorCenter/majorDetail.vue"),
        },
        {
          path: "/schoolLevel/courseList",
          name: "schoolCourseList",
          component: () =>
            import("@/views/schoolLevel/majorCenter/courseList.vue"),
        },
        {
          path: "/schoolLevel/resourceList",
          name: "schoolResourceList",
          component: () =>
            import("@/views/schoolLevel/majorCenter/resourceList.vue"),
        },
        {
          path: "/schoolLevel/courseCenter",
          name: "schoolCourseCenter",
          component: () => import("@/views/schoolLevel/courseCenter.vue"),
        },
        {
          path: "/schoolLevel/courseResourceCenter",
          name: "schoolCourseResourceCenter",
          component: () =>
            import("@/views/schoolLevel/courseResourceCenter.vue"),
        },
        // 专业
        {
          path: "/schoolLevel/majorCenter",
          name: "schoolMajorCenter",
          component: () => import("@/views/schoolLevel/majorCenter.vue"),
        },
        // 专业资源中心
        {
          path: "/schoolLevel/majorResourceCenter",
          name: "schoolMajorResourceCenter",
          component: () =>
            import("@/views/schoolLevel/majorResourceCenter.vue"),
        },
        // 专业
        {
          path: "/schoolLevel/majorCenter1",
          name: "schoolMajorCenter1",
          component: () => import("@/views/schoolLevel/majorCenter1.vue"),
        },
        // 专业
        {
          path: "/schoolLevel/majorCenter2",
          name: "schoolMajorCenter2",
          component: () => import("@/views/schoolLevel/majorCenter2.vue"),
        },
        // 资源
        {
          path: "/schoolLevel/resourceCenter",
          name: "schoolResourceCenter",
          component: () => import("@/views/schoolLevel/resourceCenter.vue"),
        },

        {
          path: "/schoolLevel/virtualCenter",
          name: "schoolVirtualCenter",
          component: () => import("@/views/schoolLevel/virtualCenter.vue"),
        },
        // 专业详情模板1
        {
          path: "/schoolLevel/majorDetail1",
          name: "schoolMajorDetail1",
          component: () =>
            import("@/views/schoolLevel/majorDetailTem/majorDetail1.vue"),
        },
        // 专业详情模板2
        {
          path: "/schoolLevel/majorDetail2",
          name: "schoolMajorDetail2",
          component: () =>
            import("@/views/schoolLevel/majorDetailTem/majorDetail2.vue"),
        },
        // {
        //   path: "/home",
        //   name: "Home",
        //   component: () => import("@/views/home"),
        // },
        {
          path: "/majorCenter/home",
          name: "majorCenterHome",
          component: () => import("@/views/schoolLevel/majorCenter/majorHome"),
        },
        {
          path: "/majorCenter/index",
          name: "majorCenter",
          component: () => import("@/views/schoolLevel/majorCenter/index"),
        },
        {
          path: "/majorCenter/detail",
          name: "majorDetail",
          component: () =>
            import("@/views/schoolLevel/majorCenter/majorDetail"),
        },
        {
          path: "/courseCenter/index",
          name: "courseCenter",
          component: () => import("@/views/schoolLevel/courseCenter/index"),
        },
        {
          path: "/courseCenter/detail",
          name: "courseDetail",
          component: () =>
            import("@/views/schoolLevel/courseCenter/courseDetail"),
        },
        {
          path: "/resourceCenter/index",
          name: "resourceCenter",
          component: () => import("@/views/schoolLevel/resourceCenter/index"),
        },
        {
          path: "/resourceCenter/detail",
          name: "resourceDetail",
          component: () => import("@/views/schoolLevel/resourceCenter/detail"),
        },
        {
          path: "/index",
          name: "index",
          component: () => import("@/views/home"),
        },
        // 课程详情页
        {
          path: "/course/detail",
          name: "HgcourseDetail",
          component: () => import("@/views/teacher/course/courseDetail"),
        },
        // 课程中心页
        {
          path: "/course/center",
          name: "HgcourseCenter",
          component: () => import("@/views/teacher/course/courseCenter"),
        },
        //1+X证书
        {
          path: "/xcertificate",
          name: "xcertificate",
          component: () => import("@/views/teacher/xcertificate.vue"),
        },
        // 证书查询
        {
          path: "/certificate",
          name: "certificate",
          component: () => import("@/views/certificate-inquires/index.vue"),
          redirect: "/certificateQuery",
          children: [
            {
              path: "/certificateQuery",
              name: "certificateQuery",
              component: () => import("@/views/certificate-inquires/query.vue"),
            },
            {
              path: "/certificateDetails",
              name: "certificateDetails",
              component: () =>
                import("@/views/certificate-inquires/details.vue"),
            },
          ],
        },
        // 我的教学
        {
          path: "/teacher/index",
          name: "myTeaching",
          component: () => import("@/views/teacher/myTeaching/index.vue"),
        },
        {
          path: "/teacher/index/detail",
          name: "myTeachingDetail",
          component: () => import("@/views/teacher/myTeaching/detail.vue"),
        },
        // 我的教学开课详情页
        {
          path: "/teacher/myTeaching",
          name: "personageCenter",
          component: () => import("@/views/teacher/myTeaching/layout.vue"),
          redirect: "/teacher/myTeaching/courseSet/layout",
          children: [
            // 开课设置
            {
              path: "/teacher/myTeaching/courseSet/layout",
              name: "CourseSet",
              component: () =>
                import("@/views/teacher/myTeaching/courseSet/layout"),
              redirect: "/teacher/myTeaching/courseSet/teachingArrangement",
              children: [
                // 教学安排
                {
                  path: "/teacher/myTeaching/courseSet/teachingArrangement",
                  name: "CourseSetTeachingArrangement",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/courseSet/teachingArrangement"
                    ),
                },
                // 学习设置
                {
                  path: "/teacher/myTeaching/courseSet/learningSettings",
                  name: "CourseSetLearningSettings",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/courseSet/learningSettings"
                    ),
                },
                // 评分标准
                {
                  path: "/teacher/myTeaching/courseSet/certificate",
                  name: "CourseSetCertificate",
                  component: () =>
                    import("@/views/teacher/myTeaching/courseSet/certificate"),
                },
                // 学生证书设置
                {
                  path: "/teacher/myTeaching/courseSet/certificateSet",
                  name: "CourseSetCertificateSet",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/courseSet/certificateSet"
                    ),
                },
                // 我的学生
                {
                  path: "/teacher/myTeaching/myStudent/myStudent",
                  name: "CourseSetMyStudent",
                  component: () =>
                    import("@/views/teacher/myTeaching/myStudent/myStudent"),
                },
                // 补充信息
                {
                  path: "/teacher/myTeaching/courseSet/supplementaryInformation",
                  name: "CourseSetSupplementaryInformation",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/courseSet/supplementaryInformation"
                    ),
                },
              ],
            },
            // 课程建设
            {
              path: "/teacher/myTeaching/courseConstruction/layout",
              name: "Construction",
              component: () =>
                import("@/views/teacher/myTeaching/courseConstruction/layout"),
              redirect: "/teacher/myTeaching/courseConstruction/courseInfo",
              children: [
                // 课程信息
                {
                  path: "/teacher/myTeaching/courseConstruction/courseInfo",
                  name: "ConstructionCourseInfo",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/courseConstruction/courseInfo"
                    ),
                },
                // 教学团队
                {
                  path: "/teacher/myTeaching/courseConstruction/teachingTeam",
                  name: "ConstructionTeachingTeam",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/courseConstruction/teachingTeam"
                    ),
                },
                // 教学内容
                {
                  path: "/teacher/myTeaching/courseConstruction/teachingContent",
                  name: "ConstructionTeachContent",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/courseConstruction/teachingContent/index.vue"
                    ),
                },
                // 教学素材
                {
                  path: "/teacher/myTeaching/courseConstruction/teachMaterial",
                  name: "ConstructionTeachMaterial",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/courseConstruction/teachMaterial.vue"
                    ),
                },
                // 新增考试
                {
                  path: "/teacher/myTeaching/courseConstruction/teachingContent/addExamination",
                  name: "ConstructionTeachContentAddExam",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/courseConstruction/teachingContent/addExamination"
                    ),
                },
                // 题库
                {
                  path: "/teacher/myTeaching/courseConstruction/BaseTestManagement",
                  name: "ConstructionBaseTestManagement",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/courseConstruction/BaseTestManagement"
                    ),
                },
              ],
            },
            // 课程教学
            {
              path: "/teacher/myTeaching/myStudent/layout",
              name: "MyStudent",
              component: () =>
                import("@/views/teacher/myTeaching/myStudent/layout"),
              redirect: "/teacher/myTeaching/myStudent/notice",
              children: [
                // 通知公告
                {
                  path: "/teacher/myTeaching/myStudent/notice",
                  name: "MyStudentNotice",
                  component: () =>
                    import("@/views/teacher/myTeaching/myStudent/notice"),
                },
                // 班级分配
                {
                  path: "/teacher/myTeaching/myStudent/classAssignment",
                  name: "MyStudentClassAssignment",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/classAssignment"
                    ),
                },
                // 作业测验
                {
                  path: "/teacher/myTeaching/myStudent/homeworkTest",
                  name: "MyStudentHomeworkTest",
                  component: () =>
                    import("@/views/teacher/myTeaching/myStudent/homeworkTest"),
                },
                // 考试
                {
                  path: "/teacher/myTeaching/myStudent/examination/testList",
                  name: "MyStudentTestList",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/examination/testList"
                    ),
                },
                // 考试详情
                {
                  path: "/teacher/myTeaching/myStudent/examination/testDetail",
                  name: "MyStudentTestDetail",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/examination/testDetail"
                    ),
                },
                // 考试预览
                {
                  path: "/teacher/myTeaching/myStudent/examination/testQuestions",
                  name: "MyStudentTestQuestions",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/examination/testQuestions"
                    ),
                },
                // 已批学生
                {
                  path: "/teacher/myTeaching/myStudent/examination/isGroupStudent",
                  name: "MyStudentTestIsGroupStudent",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/examination/isGroupStudent"
                    ),
                },
                // 未批学生
                {
                  path: "/teacher/myTeaching/myStudent/examination/noBatchStudent",
                  name: "MyStudentTestNoBatchStudent",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/examination/noBatchStudent"
                    ),
                },
                // 教师批阅
                {
                  path: "/teacher/myTeaching/myStudent/examination/examinesStudent",
                  name: "MyStudentTestExaminesStudent",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/examination/examinesStudent"
                    ),
                },
                // 教师已批详情
                {
                  path: "/teacher/myTeaching/myStudent/examination/stuAnswer",
                  name: "MyStudentTestStuAnswer",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/examination/stuAnswer"
                    ),
                },
                // 未交学生
                {
                  path: "/teacher/myTeaching/myStudent/examination/makingStudent",
                  name: "MyStudentTestMakingStudent",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/examination/makingStudent"
                    ),
                },
                // 考试分析
                {
                  path: "/teacher/myTeaching/myStudent/examination/testAnalyse",
                  name: "MyStudentTestAnalyse",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/examination/testAnalyse"
                    ),
                },
                // 考试监控
                {
                  path: "/teacher/myTeaching/myStudent/examination/testMonitoring",
                  name: "MyStudentTestMonitoring",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/examination/testMonitoring"
                    ),
                },
                // 考试监控异常详情
                {
                  path: "/teacher/myTeaching/myStudent/examination/abnormalList",
                  name: "MyStudentAbnormalList",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/examination/abnormalList"
                    ),
                },
                // 讨论区
                {
                  path: "/teacher/myTeaching/myStudent/discuss/index",
                  name: "MyStudentDiscuss",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/discuss/index.vue"
                    ),
                },
                // 我的学生
                {
                  path: "/teacher/myTeaching/myStudent/myStudent",
                  name: "MyStudentMyStudent",
                  component: () =>
                    import("@/views/teacher/myTeaching/myStudent/myStudent"),
                },
                // 学生成绩
                {
                  path: "/teacher/myTeaching/myStudent/studentGrada/index",
                  name: "MyStudentStudentGrade",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/studentGrada/index"
                    ),
                },
                // 学生成绩评定
                {
                  path: "/teacher/myTeaching/myStudent/studentGrada/achievementEvaluation",
                  name: "MyStudentStudentAchievementEvaluation",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/studentGrada/achievementEvaluation"
                    ),
                },
                // 学生证书列表
                {
                  path: "/teacher/myTeaching/myStudent/studentCertificateList",
                  name: "MyStudentCertificateList",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/certificateList"
                    ),
                },
                // 成绩分析
                {
                  path: "/teacher/myTeaching/myStudent/achievementAnalysis",
                  name: "MyStudentStudentAnalysis",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/achievementAnalysis"
                    ),
                },
              ],
            },
            // 菜单设置
            {
              path: "/teacher/myTeaching/menuSet/index",
              name: "menuSet",
              component: () =>
                import("@/views/teacher/myTeaching/menuSet/index"),
            },
            // 开课统计
            {
              path: "/teacher/myTeaching/classOfStatistical",
              name: "classOfStatistical",
              component: () =>
                import(
                  "@/views/teacher/myTeaching/class-of-statistical/layout"
                ),
              redirect: "/teacher/myTeaching/classOfStatistical/index",
              children: [
                {
                  path: "/teacher/myTeaching/classOfStatistical/index",
                  name: "classOfStatisticalIndex",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/class-of-statistical/index.vue"
                    ),
                },
                // 学生成绩评定
                {
                  path: "/teacher/myTeaching/myStudent/studentGrada/achievementEvaluation",
                  name: "classOfAchievementEvaluation",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/studentGrada/achievementEvaluation"
                    ),
                },
                // 学生证书列表
                {
                  path: "/teacher/myTeaching/myStudent/studentCertificateList",
                  name: "classOfCertificateList",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/certificateList"
                    ),
                },
                // 成绩分析
                {
                  path: "/teacher/myTeaching/myStudent/achievementAnalysis",
                  name: "classOfStudentAnalysis",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/myStudent/achievementAnalysis"
                    ),
                },
                // 教学资源统计
                {
                  path: "/teacher/myTeaching/classOfStatistical/teacherRes",
                  name: "classOfTeacherRes",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/class-of-statistical/teacherRes"
                    ),
                },
                // 学生学习统计
                {
                  path: "/teacher/myTeaching/classOfStatistical/stuStudy",
                  name: "classOfStuStudy",
                  component: () =>
                    import(
                      "@/views/teacher/myTeaching/class-of-statistical/stuStudy"
                    ),
                },
              ],
            },
            // 知识图谱
            {
              path: "/teacher/myTeaching/knowledgeGraph/index",
              name: "knowledgeGraph",
              component: () =>
                import("@/views/teacher/myTeaching/knowledgeGraph/index.vue"),
            },
          ],
        },
        // 学校管理
        {
          path: "/teacher/schoolManage",
          name: "schoolManage",
          component: () => import("@/views/teacher/schoolManage/layout.vue"),
          redirect: "/teacher/schoolManage/basicInfo",
          children: [
            {
              //基础信息
              path: "/teacher/schoolManage/basicInfo",
              name: "schoolManageBasicInfo",
              component: () =>
                import("@/views/teacher/schoolManage/basicInfo/index.vue"),
              redirect: "/teacher/schoolManage/basicInfo/schoolInfo",
              children: [
                //学校信息
                {
                  path: "/teacher/schoolManage/basicInfo/schoolInfo",
                  name: "schoolManageBasicSchoolInfo",
                  component: () =>
                    import(
                      "@/views/teacher/schoolManage/basicInfo/schoolInfo.vue"
                    ),
                },
                //院系管理
                {
                  path: "/teacher/schoolManage/basicInfo/facultyManage",
                  name: "schoolManageBasicFacultyManage",
                  component: () =>
                    import(
                      "@/views/teacher/schoolManage/basicInfo/facultyManage.vue"
                    ),
                },
                //专业管理
                {
                  path: "/teacher/schoolManage/basicInfo/majorManage",
                  name: "schoolManageBasicMajorManage",
                  component: () =>
                    import(
                      "@/views/teacher/schoolManage/basicInfo/majorManage.vue"
                    ),
                },
                //班级管理
                {
                  path: "/teacher/schoolManage/basicInfo/classManage",
                  name: "schoolManageBasicClassManage",
                  component: () =>
                    import(
                      "@/views/teacher/schoolManage/basicInfo/classManage.vue"
                    ),
                },
                //课程管理
                {
                  path: "/teacher/schoolManage/basicInfo/courseManage",
                  name: "schoolManageBasicCourseManage",
                  component: () =>
                    import(
                      "@/views/teacher/schoolManage/basicInfo/courseManage.vue"
                    ),
                },
                //课程管理--开课设置
                {
                  path: "/teacher/schoolManage/basicInfo/startClassManageList",
                  name: "schoolManageBasicCourseManageList",
                  component: () =>
                    import(
                      "@/views/teacher/schoolManage/basicInfo/startClassManageList.vue"
                    ),
                },
                //课程管理--开课设置--开课详情
                {
                  path: "/teacher/schoolManage/basicInfo/startClassManage",
                  name: "schoolManageBasicCourseManageStartClassManage",
                  component: () =>
                    import(
                      "@/views/teacher/schoolManage/basicInfo/startClassManage.vue"
                    ),
                  redirect:
                    "/teacher/schoolBasicCourseManage/startClassManage/courseInformation",
                  children: [
                    //开课信息
                    {
                      path: "/teacher/schoolBasicCourseManage/startClassManage/courseInformation",
                      name: "schoolManageBasicCourseManageStartClassManageCourseInformation",
                      component: () =>
                        import(
                          "@/views/teacher/schoolManage/startClassManage/courseInformation.vue"
                        ),
                    },
                    //教学内容
                    {
                      path: "/teacher/schoolBasicCourseManage/startClassManage/teachContent",
                      name: "schoolManageBasicCourseManageStartClassManageTeachContent",
                      component: () =>
                        import(
                          "@/views/teacher/schoolManage/startClassManage/teachContent.vue"
                        ),
                    },
                    //教学团队
                    {
                      path: "/teacher/schoolBasicCourseManage/startClassManage/teachTeam",
                      name: "schoolManageBasicCourseManageStartClassManageTeachTeam",
                      component: () =>
                        import(
                          "@/views/teacher/schoolManage/startClassManage/teachTeam.vue"
                        ),
                    },
                  ],
                },
                //审核设置
                {
                  path: "/teacher/schoolManage/basicInfo/examineSetting",
                  name: "schoolManageBasicExamineSetting",
                  component: () =>
                    import(
                      "@/views/teacher/schoolManage/basicInfo/examineSetting.vue"
                    ),
                },
              ],
            },
            //开课管理
            {
              path: "/teacher/schoolManage/startClassManage",
              name: "schoolManageStartClassManage",
              component: () =>
                import(
                  "@/views/teacher/schoolManage/startClassManage/index.vue"
                ),
            },
            //审核
            {
              path: "/teacher/schoolManage/startClassManage/layout",
              name: "schoolManageStartClassManageLayout",
              component: () =>
                import(
                  "@/views/teacher/schoolManage/startClassManage/layout.vue"
                ),
              redirect:
                "/teacher/schoolManage/startClassManage/courseInformation",
              children: [
                //开课信息
                {
                  path: "/teacher/schoolManage/startClassManage/courseInformation",
                  name: "schoolManageStartClassManageCourseInformation",
                  component: () =>
                    import(
                      "@/views/teacher/schoolManage/startClassManage/courseInformation.vue"
                    ),
                },
                //教学内容
                {
                  path: "/teacher/schoolManage/startClassManage/teachContent",
                  name: "schoolManageStartClassManageTeachContent",
                  component: () =>
                    import(
                      "@/views/teacher/schoolManage/startClassManage/teachContent.vue"
                    ),
                },
                //教学团队
                {
                  path: "/teacher/schoolManage/startClassManage/teachTeam",
                  name: "schoolManageStartClassManageTeachTeam",
                  component: () =>
                    import(
                      "@/views/teacher/schoolManage/startClassManage/teachTeam.vue"
                    ),
                },
              ],
            },
            //教师管理
            {
              path: "/teacher/schoolManage/teacherManage",
              name: "schoolManageTeacherManage",
              component: () =>
                import("@/views/teacher/schoolManage/teacherManage.vue"),
            },
            //学生管理
            {
              path: "/teacher/schoolManage/studentManage",
              name: "schoolManageStudentManage",
              component: () =>
                import("@/views/teacher/schoolManage/studentManage.vue"),
            },
            //通知公告
            {
              path: "/teacher/schoolManage/notice",
              name: "schoolManageNotice",
              component: () =>
                import("@/views/teacher/schoolManage/notice.vue"),
            },
            //评论审核
            {
              path: "/teacher/comment/audit",
              name: "commentAudit",
              component: () =>
                import(
                  "@/views/teacher/schoolManage/comment/comment-audit.vue"
                ),
            },
          ],
        },
        // 课程学习
        {
          path: "/teacher/courseLearning",
          name: "courseLearning",
          component: () => import("@/views/teacher/courseLearning/layout.vue"),
          redirect: "/teacher/courseLearning/courseHome",
          children: [
            //课程首页
            {
              path: "/teacher/courseLearning/courseHome",
              name: "courseHome",
              component: () =>
                import("@/views/teacher/courseLearning/courseHome"),
            },
            //课程公告
            {
              path: "/teacher/courseLearning/courseNotice",
              name: "courseNotice",
              component: () =>
                import("@/views/teacher/courseLearning/courseNotice"),
            },
            //课程学习
            {
              path: "/teacher/courseLearning/courseLearn",
              name: "courseLearn",
              component: () =>
                import("@/views/teacher/courseLearning/courseLearn"),
            },
            //作业测验
            {
              path: "/teacher/courseLearning/testHomework/index",
              name: "testHomeworkIndex",
              component: () =>
                import("@/views/teacher/courseLearning/testHomework/index.vue"),
              redirect: "/teacher/courseLearning/testHomework/whole",
              children: [
                // 全部
                {
                  path: "/teacher/courseLearning/testHomework/whole",
                  name: "courseLearningTestHomeworkWhole",
                  component: () =>
                    import(
                      "@/views/teacher/courseLearning/testHomework/whole.vue"
                    ),
                },
                // 作业
                {
                  path: "/teacher/courseLearning/testHomework/homework",
                  name: "courseLearningTestHomeworkHomework",
                  component: () =>
                    import(
                      "@/views/teacher/courseLearning/testHomework/homework.vue"
                    ),
                },
                // 测验
                {
                  path: "/teacher/courseLearning/testHomework/test",
                  name: "courseLearningTestHomeworkTest",
                  component: () =>
                    import(
                      "@/views/teacher/courseLearning/testHomework/test.vue"
                    ),
                },
              ],
            },
            //阶段考试
            {
              path: "/teacher/courseLearning/test/index",
              name: "testIndex",
              component: () =>
                import("@/views/teacher/courseLearning/test/index.vue"),
            },
            //讨论区
            {
              path: "/teacher/courseLearning/discuss/index",
              name: "discussIndex",
              component: () =>
                import("@/views/teacher/courseLearning/discuss/index.vue"),
              redirect: "/teacher/courseLearning/discuss/wholeDiscuss",
              children: [
                // 全部讨论
                {
                  path: "/teacher/courseLearning/discuss/wholeDiscuss",
                  name: "courseLearningDiscussWholeDiscuss",
                  component: () =>
                    import(
                      "@/views/teacher/courseLearning/discuss/wholeDiscuss.vue"
                    ),
                },
                // 老师答疑
                {
                  path: "/teacher/courseLearning/discuss/teachAnswer",
                  name: "courseLearningDiscussTeachAnswer",
                  component: () =>
                    import(
                      "@/views/teacher/courseLearning/discuss/teachAnswer.vue"
                    ),
                },
                // 课堂交流
                {
                  path: "/teacher/courseLearning/discuss/classCommunication",
                  name: "courseLearningDiscussClassCommunication",
                  component: () =>
                    import(
                      "@/views/teacher/courseLearning/discuss/classCommunication.vue"
                    ),
                },
                // 综合讨论
                {
                  path: "/teacher/courseLearning/discuss/comprehensiveDisscuss",
                  name: "courseLearningDiscussComprehensiveDiscuss",
                  component: () =>
                    import(
                      "@/views/teacher/courseLearning/discuss/comprehensiveDisscuss.vue"
                    ),
                },
              ],
            },
            //评分标准
            {
              path: "/teacher/courseLearning/scoringCriteria/index",
              name: "scoringCriteriaIndex",
              component: () =>
                import(
                  "@/views/teacher/courseLearning/scoringCriteria/index.vue"
                ),
            },
            //学习笔记
            {
              path: "/teacher/courseLearning/learningNotes",
              name: "learningNotesLayout",
              component: () =>
                import(
                  "@/views/teacher/courseLearning/learningNotes/layout.vue"
                ),

              redirect: "/teacher/courseLearning/learningNotes/index",
              children: [
                {
                  path: "/teacher/courseLearning/learningNotes/index",
                  name: "learningNotes",
                  component: () =>
                    import(
                      "@/views/teacher/courseLearning/learningNotes/index.vue"
                    ),
                },
                {
                  path: "/teacher/courseLearning/learningNotes/addNotes",
                  name: "learningNotesAdd",
                  component: () =>
                    import(
                      "@/views/teacher/courseLearning/learningNotes/addNotes.vue"
                    ),
                },
              ],
            },
            //教学素材
            {
              path: "/teacher/courseLearning/shareNotes",
              name: "shareNotes",
              component: () =>
                import("@/views/teacher/courseLearning/shareNotes.vue"),
            },
            //教学素材
            {
              path: "/teacher/courseLearning/teachingMaterialList",
              name: "teachingMaterialList",
              component: () =>
                import(
                  "@/views/teacher/courseLearning/teachingMaterialList.vue"
                ),
            },
            //错题本
            {
              path: "/teacher/courseLearning/correctionNotebook",
              name: "correctionNotebook",
              component: () =>
                import("@/views/teacher/courseLearning/correctionNotebook.vue"),
            },
            //课程评价
            {
              path: "/teacher/courseLearning/courseEvaluate",
              name: "courseEvaluate",
              component: () =>
                import("@/views/teacher/courseLearning/courseEvaluate.vue"),
            },
          ],
        },
        // 项目管理
        {
          path: "/project/index",
          name: "projectIndex",
          component: () => import("@/views/project/index"),
        },
        // 项目管理
        {
          path: "/project/myProject",
          name: "myProject",
          component: () => import("@/views/project/myProject"),
          redirect: "/project/major",
          children: [
            //专业基础信息
            {
              path: "/project/major",
              name: "major",
              component: () => import("@/views/project/major.vue"),
            },
            //栏目管理
            {
              path: "/project/column",
              name: "column",
              component: () => import("@/views/project/column.vue"),
              // children: [
              //   {
              //     path: "/project/column/:id",
              //     name: "column",
              //     component: () => import("@/views/project/column/index.vue"),
              //   },
              // ],
            },
            //教师管理
            {
              path: "/project/teacher",
              name: "teacher",
              component: () => import("@/views/project/teacher.vue"),
            },
            //课程
            {
              path: "/project/curriculum",
              name: "curriculum",
              component: () => import("@/views/project/material.vue"),
            },
            //资源
            {
              path: "/project/resource",
              name: "resource",
              component: () => import("@/views/project/material.vue"),
            },
            //素材
            {
              path: "/project/material",
              name: "material",
              component: () => import("@/views/project/material.vue"),
            },

            //联盟院校
            {
              path: "/project/allianceCollege",
              name: "allianceCollege",
              component: () => import("@/views/project/allianceCollege.vue"),
            },

            //快速链接
            {
              path: "/project/quickLink",
              name: "quickLink",
              component: () => import("@/views/project/quickLink.vue"),
            },
            //快速链接
            {
              path: "/project/allianceEnterprise",
              name: "allianceEnterprise",
              component: () => import("@/views/project/allianceEnterprise.vue"),
            },

            //项目成员
            {
              path: "/project/projectMember",
              name: "projectMember",
              component: () => import("@/views/project/projectMember.vue"),
            },
            //留言板
            {
              path: "/project/messageBoard",
              name: "messageBoard",
              component: () => import("@/views/project/messageBoard.vue"),
            },
          ],
        },
        // 个人中心
        {
          path: "/teacher/personalCenter",
          name: "personalCenter",
          component: () => import("@/views/teacher/personalCenter/layout.vue"),
          redirect: "/teacher/personalCenter/personalData",
          children: [
            //个人资料
            {
              path: "/teacher/personalCenter/personalData",
              name: "personalCenterPersonalData",
              component: () =>
                import("@/views/teacher/personalCenter/personalData.vue"),
            },
            //修改密码
            {
              path: "/teacher/personalCenter/changePassword",
              name: "personalCenterChangePassword",
              component: () =>
                import("@/views/teacher/personalCenter/changePassword.vue"),
            },
            //关联账号
            {
              path: "/teacher/personalCenter/associatedAccount",
              name: "personalCenterAssociatedAccount",
              component: () =>
                import("@/views/teacher/personalCenter/associatedAccount.vue"),
            },
            //用户认证
            {
              path: "/teacher/personalCenter/certificationManage",
              name: "personalCenterCertificationManage",
              component: () =>
                import(
                  "@/views/teacher/personalCenter/certificationManage.vue"
                ),
            },
            //新闻公告
            {
              path: "/teacher/personalCenter/notice",
              name: "personalCenterNotice",
              component: () =>
                import("@/views/teacher/personalCenter/notice.vue"),
            },
            //我的消息
            {
              path: "/teacher/personalCenter/message",
              name: "personalCenterMessage",
              component: () =>
                import("@/views/teacher/personalCenter/message.vue"),
            },
          ],
        },
        // 我的学习
        {
          path: "/teacher/myStudy",
          name: "myStudy",
          component: () => import("@/views/teacher/myStudy/layout.vue"),
          redirect: "/teacher/myStudy/myCourse",
          children: [
            // 我的课程
            {
              path: "/teacher/myStudy/myCourse",
              name: "myCourse",
              component: () =>
                import("@/views/teacher/myStudy/myCourse/index.vue"),
            },
            // 我的培训
            {
              path: "/teacher/myStudy/myTrain",
              name: "myTrain",
              component: () =>
                import("@/views/teacher/myStudy/myTrain/index.vue"),
            },
            // 讨论区
            {
              path: "/teacher/myStudy/discussArea",
              name: "discussArea",
              component: () =>
                import("@/views/teacher/myStudy/discussArea/index.vue"),
            },
            // 我的证书
            {
              path: "/teacher/myStudy/myCertificate",
              name: "myCertificate",
              component: () =>
                import("@/views/teacher/myStudy/myCertificate/index.vue"),
            },
          ],
        },
        {
          //我的资源：个人中心
          path: "/resPersonalCenter",
          name: "resPersonalCenter",
          component: () => import("@/views/resPersonalCenter/layout"),
          redirect: "/resPersonalCenter/teacher/index",
          children: [
            // 个人中心首页
            {
              path: "/resPersonalCenter/teacher/index",
              name: "resPersonalCenterHome",
              component: () => import("@/views/resPersonalCenter/index"),
            },
            // 我的收藏
            {
              path: "/resPersonalCenter/teacher/myCollection",
              name: "myCollection",
              component: () => import("@/views/resPersonalCenter/myCollection"),
            },
            // 我的资源
            {
              path: "/resPersonalCenter/myResource",
              name: "myResources",
              component: () => import("@/views/resPersonalCenter/myResources"),
            },
            // 我的评论
            {
              path: "/resPersonalCenter/myComments",
              name: "myComments",
              component: () => import("@/views/resPersonalCenter/myComments"),
            },
            // 我的回收站
            {
              path: "/resPersonalCenter/myRecycle",
              name: "myRecycle",
              component: () => import("@/views/resPersonalCenter/myRecycle"),
            },
            // 资源审核
            {
              path: "/resPersonalCenter/resourceAudit",
              name: "resourceAudit",
              component: () =>
                import("@/views/resPersonalCenter/resourceAudit"),
            },
            // 评论审核
            {
              path: "/resPersonalCenter/commentAudit",
              name: "resCommentAudit",
              component: () => import("@/views/resPersonalCenter/commentAudit"),
            },
            // 我的消息更多
            {
              path: "/resPersonalCenter/MyMessage",
              name: "MyMessage",
              component: () => import("@/views/resPersonalCenter/MyMessage"),
            },
            // 上传资源
            {
              path: "/resPersonalCenter/uploadResources",
              name: "uploadResources",
              component: () =>
                import("@/views/resPersonalCenter/uploadResources"),
            },
          ],
        },
        {
          //我的资源：学生个人中心
          path: "/studentPersonal",
          name: "studentPersonal",
          component: () => import("@/views/studentPersonal/layout"),
          redirect: "/studentPersonal/student/index",
          children: [
            // 个人中心首页
            {
              path: "/studentPersonal/student/index",
              name: "studentPersonalIndex",
              component: () => import("@/views/studentPersonal/index"),
            },
            // 我的资源
            {
              path: "/studentPersonal/myResource",
              name: "studentMyResources",
              component: () => import("@/views/studentPersonal/myResources"),
            },
            //我的消息更多
            {
              path: "/studentPersonal/student/moreMessage",
              name: "studentPersonalMore",
              component: () => import("@/views/studentPersonal/MyMessage"),
            },
            //我的浏览
            {
              path: "/studentPersonal/student/myBrowse",
              name: "studentPersonalBrowse",
              component: () => import("@/views/studentPersonal/myBrowse"),
            },
            //我的收藏
            {
              path: "/studentPersonal/student/myCollect",
              name: "studentPersonalCollect",
              component: () => import("@/views/studentPersonal/myCollect"),
            },
            //我的评论
            {
              path: "/studentPersonal/student/myComments",
              name: "studentPersonalComments",
              component: () => import("@/views/studentPersonal/myComments"),
            },
            // 上传资源
            {
              path: "/resPersonalCenter/uploadResources",
              name: "studentUploadResources",
              component: () =>
                import("@/views/studentPersonal/uploadResources"),
            },
          ],
        },
        ...readyCourse,
        ...teachEffect,
        ...jxeffectTwo,
        {
          path: "/BaseHome",
          name: "BaseHome",
          component: () => import("@/components/BaseHome"),
        },
      ],
    },
    ...giveCourse,
    // 新课程学习页面
    {
      path: "/newCourseLearn",
      name: "newCourseLearn",
      component: () => import("@/views/new-course-learn/index.vue"),
    },
    // 新课程学习页面 => 2版
    {
      path: "/newCourseLearns",
      name: "newCourseLearns",
      component: () => import("@/views/new-course-learn/learn.vue"),
    },
    //回首页
    {
      path: "/supplierAllBack",
      name: "SupplierAllBack",
      component: () => import("@/views/components/supplierAllBack.vue"),
    },
    //回课程详情页
    {
      path: "/goCourseDetailBack",
      name: "goCourseDetailBack",
      component: () => import("@/views/components/goCourseDetailBack.vue"),
    },
    //回课程中心页
    {
      path: "/goCourseCenterBack",
      name: "goCourseCenterlBack",
      component: () => import("@/views/components/goCourseCenterBack.vue"),
    },
    //回课程学习页
    {
      path: "/goCourseLearn",
      name: "goCourseLearn",
      component: () => import("@/views/components/goCourseLearn.vue"),
    },
    //考试未完成--去考试
    {
      path: "/socketA",
      name: "socketA",
      component: () => import("@/views/components/basedata/socketA.vue"),
    },
    //考试完成--详情页
    {
      path: "/socketB",
      name: "socketB",
      component: () => import("@/views/components/basedata/socketB.vue"),
    },
    {
      path: "/resourcesDetail_phone/:id",
      name: "resourcesDetail_phone",
      component: () =>
        import("@/views/resPersonalCenter/resourcesDetail/detail_phone"),
    },
    // 职业技能培训中心
    {
      path: "/training",
      name: "training",
      redirect: "/training/home",
      component: () => import("@/views/training/layout"),
      children: [
        // 首页
        {
          path: "/training/index",
          name: "trainingIndex",
          component: () => import("@/views/training/index"),
        },
        // 政策法规
        {
          path: "/training/policy",
          name: "trainingIndex",
          component: () => import("@/views/training/policy/index"),
        },
        {
          path: "/training/policyDetail",
          name: "trainingPolicyDetail",
          component: () => import("@/views/training/policy/detail.vue"),
        },
        //在线课程
        {
          path: "/training/course",
          name: "trainingIndex",
          component: () => import("@/views/training/course/index.vue"),
        },
        {
          path: "/training/courseDetail",
          name: "trainingCourseDetail",
          component: () => import("@/views/training/course/detail.vue"),
        },
      ],
    },
  ],
});
// const router = createRouter({
//   history: createWebHistory(),
//   routes,
// });

export default router;
